module.exports = __webpack_public_path__ + "img/laptop@2x.8d3d8982.png";